// eslint-disable-next-line import/no-cycle
import { IMetadata } from "@/utils/seo";
// eslint-disable-next-line import/no-cycle
import {
    ActivityReableTO,
    ReviewReadableTO,
    SectionsTitleText,
} from "./common/common";

export interface CardBrochuresContent {
    title: SectionsTitleText[];
    subTitle: SectionsTitleText[];
    imagesrc?: string;
}

export interface CardTikTokContent {
    name: string;
    place: string;
    userImageUrl: string;
    imageCoverUrl: string;
    videoUrl: string;
}

export interface CardStoriesContent {
    title: string;
    imgUrl: string;
    slugId: string;
    readTime: string;
    vendor: string;
    date: string;
    tag?: string;
}

export interface CardVisitContent {
    imageUrl: string;
    title: string;
    place: string;
    region: string;
}

export interface CardReviewContent {
    review: string;
    imgUrl: string;
    user: string;
    work: string;
}

export interface StepsInfo {
    title: SectionsTitleText[];
    subTitle: SectionsTitleText[];
}

interface TravelExperiencesTags {
    id: string;
    value: string;
}

export interface TravelExperiencesContent {
    title: string;
    // eslint-disable-next-line
    icon: any;
    tags: TravelExperiencesTags[];
    // eslint-disable-next-line
    bulletIcon?: any;
    onClick: () => void;
}

export interface SmartCardContent {
    index: number;
    image: string;
    title: string;
    description: string;
    onClick: (el: string, index: number) => void;
}

export interface ISmartCard {
    id: string;
    value: SmartCardContent;
}

export interface RadioButtons {
    id: string;
    value: {
        image?: string;
        title: string;
        description?: string;
    };
}

export interface ToursEntity {
    onlyPremium?: boolean;
    _id: string;
    title?: string;
    price: string;
    startingPrice?: number;
    destinations?: string[] | null;
    image: string;
    duration: number;
    nightDuration: number;
    reviews: number;
    rating: number;
    requestAQuote: boolean;
    requestAQuoteActivities: ActivityReableTO[];
    metadata?: IMetadata;
    _eurPrices?: Record<string, number>;
    priority?: number;
}

interface ToursByEntity {
    title: string;
    body: string;
    image: string;
    tours?: ToursEntity[] | null;
}

export interface Delta {
    ops: unknown[];
}

export interface Section {
    title: Delta;
    subtitle: Delta;
    buttonHome?: Delta;
    buttonHomeUrl?: string;
    borderBtn?: string;
    navbarButton?: string;
    navbarButtonUrl?: string;
}

export interface ToursByTourTypeEntity extends ToursByEntity {
    tourType: string;
    type: string;
}

export interface ToursByDestinationEntity extends ToursByEntity {
    city: string;
}

export interface DestinationToExploreEntity {
    city: string;
    // searchableLabel: string; // Commentato: non più necessario, ma mantenuto per possibile riattivazione futura
    region: string;
    image: string;
    title: string;
    body: string;
    latitude: string;
    longitude: string;
    aggregationId: string;
    priority?: number;
}
export interface BrochuresEntity {
    type: string;
    description?: string;
    brochure: string;
}

export interface StaticMediaEntity {
    headImage: string;
    previewImageVideo: string;
    stepperImage: string;
    video: string;
    whatDoYouExpectFrom: Section;
    bannerHome: Section;
    destinations: Section;
    videoReviews: Section;
    metadata?: IMetadata;
}

export interface VideoreviewsEntity {
    _id: string;
    name: string;
    lastname: string;
    city: string;
    avatar: string;
    previewImage: string;
    countryPrefix: string;
    video: string;
    status: string;
}

export interface HomeResponseTO {
    destinationToExplore?: DestinationToExploreEntity[] | null;
    staticMedia: StaticMediaEntity;
    reviews?: ReviewReadableTO[] | null;
}

export enum EBrochuresType {
    ALL,
    ACROSSITALY,
    INTOTHEREGION,
    DOWNTHECITY,
}
